module.exports = __webpack_public_path__ + "static/media/1_A1_26.e7f5c9c5.png";